
Greenmile.Event = Greenmile.Event || {};

Greenmile.Event.AddAttribute = {

    getButtonListenerFn: function(bubblingTextArea, canvas) {

        return (event) => {
          const appendBubble = document.createElement('div');
          const availableTags = Greenmile.Event.AutoComplete.availableTags;

          const itemClick = function (event) {

            const bubbleParent = appendBubble.parentNode;
            if (bubbleParent) {
              bubbleParent.removeChild(appendBubble);
            }
            bubblingTextArea.value += event.target.getAttribute('tag-key');
            Greenmile.Event.AddAttribute.updateBubblingMask(bubblingTextArea.value);
          };

          for (let i = 0; i < availableTags.length; i++) {
            const item = document.createElement('div');
            item.innerHTML = Monet.I18n.getResourcesByKey('SelectKeyResource.' + availableTags[i]);
            item.setAttribute('tag-key', availableTags[i]);
            item.removeEventListener('click', itemClick);
            item.addEventListener('click', itemClick);
            appendBubble.appendChild(item);
          }

          appendBubble.id = 'append-bubble';
          const previousBubble = canvas.querySelector('#append-bubble');
          if (previousBubble) {
            canvas.removeChild(previousBubble);
          }
          canvas.appendChild(appendBubble);

          event.stopPropagation();
        }

    },

    updateBubblingMask: function (textValue, parentClass) {
        const bubblingMask = document.querySelector(`${parentClass} #bubbling-mask`);

        if (textValue) {
          const words   = textValue.split(' ');
          const regex   = /@([^\s]+)@/;
          let newHTML = '';

          for (let i = 0; i < words.length; i++) {
            if (regex.test(words[i])) {

              const bubbleWord     = words[i].match(regex)[1];
              const  bubbleTag      = words[i].match(regex)[0];
              const  bubble         = document.createElement('span');
              const  leftAtSpan     = document.createElement('span');
              const  rightAtSpan    = document.createElement('span');
              const  tagIndex       = words[i].indexOf(bubbleTag);
              const  leftLeftOvers  = words[i].substring(0, tagIndex);
              const  rightLeftOvers = words[i].substring(leftLeftOvers.length + bubbleTag.length);

              leftAtSpan.className = 'bubbling-invisible-at';
              leftAtSpan.innerHTML = '@';

              rightAtSpan.className = 'bubbling-invisible-at';
              rightAtSpan.innerHTML = '@';

              bubble.className = 'bubbling-bubble';
              bubble.innerHTML = leftAtSpan.outerHTML + Monet.I18n.getResourcesByKey('SelectKeyResource.' + bubbleWord) + rightAtSpan.outerHTML;

              newHTML += `${leftLeftOvers}${bubble.outerHTML}${rightLeftOvers}`;

            } else {
              newHTML += `${words[i]} `;
            }
          }

          try {
            const json = JSON.parse(newHTML);
            const jsonFormated = JSON.stringify(json, null, 2);

            bubblingMask.innerHTML = jsonFormated;
          } catch(err) {
            bubblingMask.innerHTML = newHTML;
          }
        } else {
          bubblingMask.innerHTML = "";
        }
    },

    prepareAddAtribute(parentClass, messageSelector, isValidatedJson = false) {
      const canvas = document.querySelector(`${parentClass}`);
      const textArea = document.querySelector(`${parentClass} ${messageSelector}`);
      const bubblingUnit = document.querySelector(`${parentClass} #bubbling-mask`);
      const bubbleButton = document.querySelector(`${parentClass} #bubble-button`);
      const erroMessage = document.querySelector(`${parentClass} span`);

      if(!canvas) {
          return;
      }

      const selectFieldList = new Greenmile.Event.SelectFieldList(`${parentClass} ${messageSelector}`);
      selectFieldList.addClickEventListener((field) => {
          if(field) {
              textArea.value += ` ${field.value}`;
              Greenmile.Event.AddAttribute.updateBubblingMask(textArea.value, parentClass);
          }
      });
      selectFieldList.setAvailableTags(Greenmile.Event.AutoComplete.loadEmailAvailableTags());
      selectFieldList.render();

      bubbleButton.appendChild(selectFieldList.elFieldList);

      textArea.addEventListener('blur', () => {
        textArea.style.opacity = 0;
        textArea.style.zIndex = 0;
        bubblingUnit.style.opacity = 1;

        if(isValidatedJson) {
          try {
            const json = JSON.parse(textArea.value);

            if(typeof json === "object") {
              const jsonFormated = JSON.stringify(json, null, 4);
              $(textArea).val(jsonFormated);
              $(erroMessage).hide();
              Greenmile.Event.AddAttribute.updateBubblingMask(textArea.value, parentClass);
              return;
            }
          } catch (error) {}
            Greenmile.Event.AddAttribute.updateBubblingMask(textArea.value, parentClass);
            $(erroMessage).show();
        } else {
          Greenmile.Event.AddAttribute.updateBubblingMask(textArea.value, parentClass);
        }
      });

      textArea.addEventListener('focus', () => {
        bubblingUnit.style.opacity = 0;
        textArea.style.opacity = 1;
        textArea.style.zIndex = 999999;
        textArea.setSelectionRange(textArea.value.length, textArea.value.length);
      });

      bubblingUnit.addEventListener('click', () => {
        textArea.focus();
      });
    }

};
